import React from "react";
import Frame from "../shared/Frame";
import Button from "components/shared/Button";
import { useNavigate, useLocation } from "react-router-dom";
import "./sorryPage.css";
import dean from "assets/shared/characters/Dean2.png";

function SorryPage() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const params = state as any;

  const title = params?.title || "Something went wrong";
  const except = params?.except || "none";

  return (
    <Frame title={title} onBackButtonClick={() => navigate(-1)}>
      <div className="links">
        {except !== "schools" && (
          <>
            <a onClick={() => navigate("/schools")}>School Sign Up</a>
            <br />
          </>
        )}

        {except !== "teachers" && (
          <>
            <a onClick={() => navigate("/teachers")}>Teacher Sign Up</a>
            <br />
          </>
        )}

        {except !== "skillcoaches" && (
          <>
            <a onClick={() => navigate("/skillcoaches")}>
              Skills Coach Sign Up
            </a>
            <br />
          </>
        )}
        {except !== "parents" && (
          <>
            <a onClick={() => navigate("/parents")}>Parent Sign Up</a>
            <br />
          </>
        )}
        {except !== "students" && (
          <>
            <a onClick={() => navigate("/students")}>Student Sign Up</a>
            <br />
          </>
        )}
      </div>
      <div className="d-flex justify-content-evenly">
        <Button
          value="Contact Us"
          btnType="green"
          onClick={() => {
            window.open("https://americau.com/sign-up/", "_blank");
          }}
        />
      </div>
    </Frame>
  );
}

export default SorryPage;
